import React, { useState, useEffect, useRef } from "react";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../startupdashboard/admin_sidebar";
import Header from "../startupdashboard/Adminheader";
import { uploadImage, getAllSectors, getAllStages, getCallToAction, fetchForums, createForum, deleteForum, updateForum, removeComment } from "../utils/api";
import ModernSidebar from "./admin_sidebar";
import ModernHeader from "./modern-header";
import { PhoneCall, Phone, MessageSquare, Edit, Heart } from "lucide-react";
import { FiDollarSign, FiPlusCircle, FiMeh } from "react-icons/fi";
import {
  IndianRupee,
  TrendingUp,
  Building2,
  MapPin,
  Target,
  Briefcase,
  Eye,
  Trash2,
  Upload,
  X,
  Check,
  AlertTriangle,
  Rocket,
  DollarSign,
  Percent,
  PieChart,
  Award,
  Play,
  RefreshCw,
} from "lucide-react";
import { ClipLoader } from "react-spinners";
import { toast } from "react-hot-toast";
import { initializePayment } from "../utils/paymentUtils";
import { PaymentType } from "../utils/paymentTypes";
import { isGuest } from "../utils/isGuest";
import { useNavigate } from "react-router-dom";
import * as moment from "moment";



const initialFormData = {
  title: "",
  description: "",
  images: []
};




const AdminForum = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [fundings, setFundings] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [fundingToDelete, setFundingToDelete] = useState(null);
  const fileInputRef = useRef(null);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [startupProfile, setStartupProfile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [loaderForm, setLoaderForm] = useState(false)
  const [previewImage, setPreviewImage] = useState(null);


  const [viewingFunding, setViewingFunding] = useState(null);

  const [showExpertModal, setShowExpertModal] = useState(false);
  const [sectorContacts, setSectorContacts] = useState({});
  const [caNumber, setCaNumber] = useState(null);
  const [fundingNumber, setFundingNumber] = useState(null);


  const userId = localStorage.getItem("startupId");
  const apiUrl = process.env.REACT_APP_API_URL;
  const queryClient = useQueryClient();
  const isGuestValid = isGuest()
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState("text");

  const [images, setImages] = useState([]); // base64 images


  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // Max 5 images
    if (formData.images.length + files.length > 3) {
      toast.error("You can upload a maximum of 3 images");
      return;
    }

    // Convert files to base64
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

    try {
      const base64Images = await Promise.all(
        files
          .filter((file) => file.type.startsWith("image/"))
          .map(toBase64)
      );

      // ✅ Update state ONCE
      setFormData((prev) => ({
        ...prev,
        images: [...prev.images, ...base64Images],
      }));
    } catch (err) {
      console.error("Image upload failed", err);
    }

    e.target.value = "";
  };






  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { data: forums, isLoading, refetch } = useQuery({
    queryKey: ["forums"],
    queryFn: fetchForums
  })

  useEffect(() => {
    console.log(forums)
  }, [forums])




  const resetForm = () => {
    setShowForm(false);
    setEditId(null);
    setFormData({
      ...initialFormData,
    });

  };

  const toggleForm = () => {
    if (showForm) {
      resetForm();
    } else {
      setShowForm(true);
      setEditId(null);
      setFormData({
        ...initialFormData,
        logoUrl: startupProfile?.logoUrl || ""
      });
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Default update
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };








  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoaderForm(true)
    try {
      if (editId) {
        const res = await updateForum(formData._id, formData)
        console.log(res)
        toast.success(res.message)
        refetch()
        toggleForm()
        setEditId(null)
        return;
      }
      const response = await createForum(formData)
      refetch()
      setShowSuccess(true)
      resetForm()
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    } catch (error) {
      console.log(error)
    } finally {
      setLoaderForm(false)
    }
  };




  const handleDelete = async () => {

    try {
      const response = await deleteForum(fundingToDelete)
      setShowDeleteConfirm(false)
      refetch()
      toast.success(response.message)
    } catch (error) {
      console.log(error)
    }

  };

  const handleView = (id) => {
    const funding = fundings.find((f) => f._id === id);
    setViewingFunding(funding);
    setShowModal(true);
  };

  const fetchStartupProfile = async () => {
    try {
      const startupId = localStorage.getItem("startupId");
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/startups/${startupId}`);
      setStartupProfile(response.data);
    } catch (error) {
      console.error("Error fetching startup profile:", error);
    }
  };

  useEffect(() => {
    fetchStartupProfile();
  }, []);

  useEffect(() => {
    if (showModal && !editingId) {
      fetchStartupProfile();
    }
  }, [showModal, editingId]);

  const onEditClick = (forum) => {
    console.log(forum)
    setEditId(forum._id)
    setFormData(forum)
    setShowForm(true);
  }

  const handleRemoveComment = async (commentID, forum) => {
    try {
      const responce = await removeComment(forum._id, commentID)
      setShowModal(false);
      setViewingFunding(null);
      toast.success(responce.message)
      refetch()
    } catch (error) {
      toast.error(error.response.data.message)
      console.log(error)
    }
  }

  useEffect(() => {
    console.log(formData)
    console.log(editId)
  }, [formData, editId])

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'waiting':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStageColor = (stage) => {
    switch (stage.toLowerCase()) {
      case 'ideation':
        return 'from-blue-500 to-indigo-500';
      case 'pre-seed':
        return 'from-purple-500 to-violet-500';
      case 'seed':
        return 'from-green-500 to-teal-500';
      case 'series a':
        return 'from-yellow-500 to-amber-500';
      case 'series b':
        return 'from-orange-500 to-red-500';
      case 'series c':
        return 'from-pink-500 to-rose-500';
      default:
        return 'from-gray-500 to-slate-500';
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setPreviewImage(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  useEffect(() => {
    console.log("previewImage:", previewImage);
  }, [previewImage])
  // 
  return (
    <>
      <div className="flex h-screen bg-gray-50">
        <ModernSidebar
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
          fullName={fullName}
          email={email}
        />

        <div className={`flex flex-col flex-1 transition-all duration-300 ${isMobile ? "ml-0" : "ml-16 md:ml-20 lg:ml-20"}`}>
          <ModernHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />

          <main className="flex-1 overflow-y-auto p-4 sm:p-6">
            <div className="">
              {/* Header Section */}
              {!showForm && (
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                  <div>
                    <h1 className="text-2xl font-bold bg-gradient-to-r from-black via-gray-900 to-slate-600 bg-clip-text text-transparent">
                      Forum Dashboard
                    </h1>
                    <p className="text-gray-600 text-sm sm:text-base mt-1 sm:mt-2">Share ideas, ask questions, and learn from other founders
                    </p>
                  </div>
                  <div className="flex gap-3">



                    <button
                      onClick={() => {
                        if (isGuestValid) {
                          toast.error("Please login to create funding!")
                          navigate('/login')
                        } else {
                          toggleForm()
                        }
                      }}
                      className="group relative overflow-hidden bg-black hover:from-blue-700 hover:to-purple-700 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg sm:rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 sm:gap-3 text-sm sm:text-base"
                    >
                      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-200"></div>
                      {showForm ? (
                        <>
                          <X className="w-4 h-4 sm:w-5 sm:h-5" />
                          <span>Close Form</span>
                        </>
                      ) : (
                        <>
                          <FiPlusCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                          <span>Create Forum</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}


              <AnimatePresence>
                {showSuccess && (
                  <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className="bg-gradient-to-r from-green-500 to-emerald-500 text-white p-3 sm:p-4 rounded-xl sm:rounded-2xl shadow-lg flex items-center gap-2 sm:gap-3 text-sm sm:text-base"
                  >
                    <Check className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                    <span className="font-semibold">Forum submitted successfully. Awaiting admin approval.</span>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Form Section */}
              <AnimatePresence>
                {showForm && (
                  <motion.div
                    initial={{ opacity: 0, y: -30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    className="  border border-white/20  rounded-xl  p-4 sm:p-6 md:p-8"
                  >
                    {/* HEADER */}
                    <div className="mb-6">
                      <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                        {editId ? "Edit Forum" : "Create post"}
                      </h2>
                      <p className="text-gray-600 text-sm">
                        Share your thoughts with the community
                      </p>
                    </div>

                    {/* TABS */}
                    <div className="flex gap-6 border-b mb-6">
                      {[
                        { key: "text", label: "Text" },
                        { key: "media", label: "Images & Video" },

                      ].map((tab) => (
                        <button
                          key={tab.key}
                          type="button"
                          onClick={() => setActiveTab(tab.key)}
                          className={`pb-2 text-sm font-semibold ${activeTab === tab.key
                            ? "border-b-2 border-black text-black"
                            : "text-gray-500"
                            }`}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>

                    <form
                      onSubmit={handleSubmit}
                      className="space-y-6"
                    >
                      {/* TITLE */}
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder="Title *"
                        maxLength={300}
                        className="
    w-full
    px-4 py-3
    rounded-xl
    bg-gray-50
    border border-gray-200
    text-sm text-gray-900
    placeholder-gray-500
    shadow-sm
    transition
    focus:bg-white
    focus:border-gray-400
    focus:ring-0
    focus:outline-none
  "
                        required
                      />


                      {/* TEXT TAB */}
                      {activeTab === "text" && (
                        <textarea
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          rows={5}
                          placeholder="Body text (optional)"
                          className=" w-full  px-4 py-3  rounded-xl  bg-gray-50  border border-gray-200  text-sm text-gray-900  placeholder-gray-500  shadow-sm  resize-none  transition  focus:bg-white  focus:border-gray-400  focus:ring-0  focus:outline-none
    "
                        />
                      )}


                      {/* MEDIA TAB */}
                      {/* MEDIA TAB */}
                      {activeTab === "media" && (
                        <div className="space-y-4">
                          {/* Upload box */}
                          <div className="border-2 border-dashed rounded-xl p-8 text-center text-sm text-gray-500">
                            <p className="mb-2">Drag and drop or upload images</p>

                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              onChange={handleImageUpload}
                              className="hidden"
                              id="imageUpload"
                            />

                            <label
                              htmlFor="imageUpload"
                              className="inline-block px-4 py-2 bg-gray-100 rounded-full cursor-pointer hover:bg-gray-200 transition"
                            >
                              Upload
                            </label>

                            <p className="text-xs text-gray-400 mt-2">
                              You can upload up to 3 images
                            </p>
                          </div>

                          {/* Image Preview Grid */}
                          {formData.images.length > 0 && (
                            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
                              {formData.images.map((img, index) => (
                                <div
                                  key={index}
                                  className="relative group rounded-xl overflow-hidden border"
                                >
                                  <img
                                    src={img}
                                    alt="preview"
                                    className="w-full h-28 object-cover"
                                  />

                                  {/* Remove Button */}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        images: prev.images.filter((_, i) => i !== index),
                                      }))
                                    }
                                    className=" absolute top-1 right-1 bg-black/60 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition
              "
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}




                      {/* LINK TAB */}
                      {activeTab === "link" && (
                        <input
                          type="url"
                          placeholder="Enter URL"
                          className="w-full px-4 py-3 border rounded-xl"
                        />
                      )}

                      {/* POLL TAB */}
                      {activeTab === "poll" && (
                        <p className="text-sm text-gray-500">
                          Poll creation coming soon
                        </p>
                      )}

                      {/* ACTIONS */}
                      <div className="flex justify-end gap-4 pt-4 border-t">
                        <button
                          type="button"
                          onClick={resetForm}
                          className="px-4 py-2 rounded-full bg-gray-100 text-sm"
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          disabled={loaderForm}
                          className={`
    px-5 py-2
    rounded-full
    text-sm font-semibold
    flex items-center justify-center gap-2
    transition
    ${loaderForm
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-black text-white hover:bg-gray-900"
                            }
  `}
                        >
                          {loaderForm ? (
                            <>
                              <ClipLoader color="#ffffff" size={16} />
                              <span>Loading...</span>
                            </>
                          ) : (
                            <span>{editId ? "Update" : "Post"}</span>
                          )}
                        </button>

                      </div>
                    </form>
                  </motion.div>
                )}
              </AnimatePresence>


              {/* Forum Cards */}
              {!showForm && forums?.data && forums?.data?.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {forums?.data?.map((forum) => (
                    <motion.div
                      key={forum._id}
                      initial={{ opacity: 0, y: 16 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                      whileHover={{ y: -4 }}
                      className="relative bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg transition-all"
                    >
                      {/* Status Badge */}
                      <span
                        className={`absolute top-4 right-4 px-3 py-1 text-[11px] font-semibold tracking-wide rounded-full ${getStatusColor(
                          forum.status
                        )}`}
                      >
                        {forum.status.toUpperCase()}
                      </span>

                      <div className="p-6 flex flex-col h-full">
                        {/* Icon */}
                        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-100 text-blue-600 mb-4">
                          <MessageSquare className="w-6 h-6" />
                        </div>

                        {/* Title */}
                        <h3 className="text-lg font-semibold text-gray-900 leading-snug mb-2 line-clamp-2">
                          {forum.title}
                        </h3>

                        {/* Description */}
                        <p className="text-sm text-gray-600 mb-6 line-clamp-3">
                          {forum.description}
                        </p>

                        {/* Spacer to push actions down */}
                        <div className="mt-auto flex items-center gap-3">
                          {/* View */}
                          <button
                            onClick={() => {
                              setShowModal(true);
                              setViewingFunding(forum);
                            }}
                            className="
    relative overflow-hidden i flex-1 flex items-center justify-center gap-2 px-5 py-2.5 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-900 transition-all duration-300 group
  "
                          >
                            <span
                              className=" pointer-events-none absolute inset-0 bg-[linear-gradient(120deg,transparent,rgba(255,255,255,0.45),transparent)] translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                            />

                            {/* Content */}
                            <span className="relative z-10">View</span>
                            <Eye className="relative z-10 w-4 h-4" />
                          </button>


                          {/* Edit */}
                          <button
                            onClick={() => onEditClick(forum)}
                            className="p-2.5 rounded-xl border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <Edit className="w-4 h-4" />
                          </button>

                          {/* Delete */}
                          <button
                            onClick={() => {
                              setFundingToDelete(forum._id);
                              setShowDeleteConfirm(true);
                            }}
                            className="p-2.5 rounded-xl border border-red-200 text-red-600 hover:bg-red-50 transition"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>


              ) : (
                <>
                  {isLoading ? (
                    <div className="flex flex-col items-center justify-center py-12 sm:py-16 md:py-20 bg-white/50 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-white/20 shadow-lg">
                      <ClipLoader
                        size={40}
                        color={"#6366f1"}
                        loading={isLoading}
                      />
                      <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mt-4 sm:mt-6 mb-2 sm:mb-3">Loading Forums ...</h3>
                      <p className="text-gray-600 text-center max-w-xs sm:max-w-md text-sm sm:text-base">
                        Please wait while we fetch your Forum information.
                      </p>
                    </div>
                  ) : (
                    !showForm && fundings.length === 0 && (
                      <div className="flex flex-col items-center justify-center py-12 sm:py-16 md:py-20 bg-white/50 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-white/20 shadow-lg">
                        <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-4 sm:p-6 rounded-full mb-4 sm:mb-6 flex items-center justify-center">
                          <Rocket className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 text-blue-600" />
                        </div>
                        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-2 sm:mb-3">No Forums yet.</h3>
                        <p className="text-gray-600 text-center max-w-xs sm:max-w-md mb-4 sm:mb-6 text-sm sm:text-base">
                          Start the conversation by creating your first forum. Ask questions, share ideas, and connect with the startup community.
                        </p>
                        <button

                          onClick={() => {
                            if (isGuestValid) {
                              toast.error("Please login to create funding!")
                              navigate('/login')
                            } else {
                              setShowForm(true)
                            }
                          }
                          }
                          className="bg-black hover:from-blue-700 hover:to-purple-700 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg sm:rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-xs sm:text-sm"
                        >
                          <FiPlusCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                          Create Your First Forum
                        </button>
                      </div>
                    )
                  )}
                </>
              )}

              {/* View Funding Modal */}
              {showModal && viewingFunding && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 ">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="bg-white rounded-xl sm:rounded-2xl shadow-xl w-full max-w-md sm:max-w-2xl max-h-[90vh] overflow-y-auto"
                  >
                    <div className="p-4 sm:p-6 md:p-8">
                      {/* Header */}
                      <div className="flex justify-between items-start mb-4 sm:mb-6">
                        <div>
                          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">
                            Forum Details
                          </h2>
                          <div
                            className={`mt-1 px-2 py-0.5 sm:px-3 sm:py-1 rounded-full text-xs font-bold border ${getStatusColor(
                              viewingFunding.status
                            )}`}
                          >
                            {viewingFunding.status.toUpperCase()}
                          </div>
                       

                        </div>
                        <button
                          onClick={() => setShowModal(false)}
                          className="text-gray-400 hover:text-gray-600"
                        >
                          <X className="w-5 h-5 sm:w-6 sm:h-6" />
                        </button>
                      </div>

                      {/* Content */}
                      <div className="space-y-5 sm:space-y-6">
                        {/* Forum Title */}
                        <div>
                          <p className="text-xs sm:text-sm text-gray-500 font-medium">
                            Forum Title
                          </p>
                          <p className="text-base sm:text-lg font-semibold text-gray-900">
                            {viewingFunding.title}
                          </p>
                        </div>



                        {/* Description */}
                        <div>
                          <p className="text-xs sm:text-sm text-gray-500 font-medium mb-1">
                            Description
                          </p>
                          <p className="text-sm sm:text-base text-gray-700 whitespace-pre-line">
                            {viewingFunding.description}
                          </p>
                        </div>

                        {/* Images */}
                        {(viewingFunding.images?.length > 0 || viewingFunding.image) && (
                          <div>
                            <p className="text-xs sm:text-sm text-gray-500 font-medium mb-2">
                              Images
                            </p>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                              {(viewingFunding.images || [viewingFunding.image]).map(
                                (img, index) =>
                                  img && (
                                    <div
                                      key={index}
                                      className="relative group overflow-hidden rounded-xl border border-gray-200"
                                    >
                                      <div
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPreviewImage(img);
                                        }}
                                        className="relative group overflow-hidden rounded-xl border border-gray-200 cursor-zoom-in"
                                      >
                                        <img
                                          src={img}
                                          alt={`forum-${index}`}
                                          className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                                        />

                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition" />
                                      </div>


                                      {/* Hover Overlay */}
                                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition" />
                                    </div>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {/* Created Date */}
                        <div>
                          <p className="text-xs sm:text-sm text-gray-500 font-medium">
                            Created On
                          </p>
                            
                          <p className="text-sm sm:text-base text-gray-800">
                            {moment(viewingFunding.createdAt).format("DD/MM/YYYY")}
                          </p>
                        </div>

                        {/* Comments Section */}
                         <div className="flex items-center gap-2 mt-2 text-sm text-gray-600">
  <Heart className="w-4 h-4 text-red-500 fill-red-500" />
  <span className="font-medium">
    {viewingFunding.likes?.length || 0} Likes
  </span>
</div>
                        <div className="border-t pt-5 sm:pt-6">
                          <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-3">
                            Comments ({viewingFunding.comments?.length || 0})
                          </h3>

                          

                          {/* Comment List */}
                          {viewingFunding.comments && viewingFunding.comments.length > 0 ? (
                            <div className="space-y-3 max-h-60 overflow-y-auto pr-1">
                              {viewingFunding.comments.map((comment) => {
                                return (
                                  <div
                                    key={comment._id}
                                    className="bg-gray-50 border border-gray-200 rounded-lg p-3"
                                  >
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                      {comment.text}
                                    </p>

                                    <div className="flex justify-between items-center mt-2 text-xs text-gray-500">
                                      <span>
                                        — {comment.startupId?.startupName || "User"}
                                      </span>

                                      <div className="flex items-center gap-3">
                                        <span>
                                          {moment(comment.createdAt).format("DD/MM/YYYY")}
                                        </span>

                                        {/* Remove Button */}

                                        <button
                                          onClick={() => handleRemoveComment(comment._id, viewingFunding)}
                                          className="text-red-600 hover:text-red-700 font-medium"
                                        >
                                          Remove
                                        </button>

                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>

                          ) : (
                            <p className="text-sm text-gray-500 italic">
                              No comments yet. Be the first to comment.
                            </p>
                          )}
                        </div>

                      </div>
                    </div>
                  </motion.div>
                </div>
              )}


              {/* Delete Confirmation Modal */}
              {showDeleteConfirm && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="bg-white rounded-xl sm:rounded-2xl shadow-lg w-full max-w-sm p-4 sm:p-6 md:p-8"
                  >
                    <div className="text-center mb-4 sm:mb-6">
                      <div className="bg-red-100 p-3 sm:p-4 rounded-full w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 flex items-center justify-center">
                        <AlertTriangle className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 text-red-600" />
                      </div>
                      <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">Delete Forum?</h2>
                      <p className="text-gray-600 text-xs sm:text-sm">
                        Are you sure you want to delete this Forum? This action cannot be undone.
                      </p>
                    </div>

                    <div className="flex gap-2 sm:gap-3 md:gap-4">
                      <button
                        onClick={() => setShowDeleteConfirm(false)}
                        className="flex-1 px-3 sm:px-4 py-2 sm:py-2.5 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg sm:rounded-xl hover:bg-gray-50 transition-all duration-200 text-xs sm:text-sm"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleDelete}
                        className="flex-1 px-3 sm:px-4 py-2 sm:py-2.5 bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 text-white font-semibold rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 text-xs sm:text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </motion.div>
                </div>
              )}

              {/* Expert Modal */}
              {showExpertModal && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[9999] p-4">
                  <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-8 relative transform animate-in zoom-in-95 duration-300 expert-modal">
                    <div className="absolute top-4 right-4">
                      <button
                        onClick={() => setShowExpertModal(false)}
                        className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
                      >
                        <X className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>

                    <div className="text-center mb-6">
                      <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                        <PhoneCall className="w-8 h-8 text-blue-600" />
                      </div>
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">Call Our Funding Expert</h2>
                      <p className="text-gray-600">
                        Get personalized assistance with your funding needs and investor relations.
                      </p>
                    </div>

                    {hasContacts() ? (
                      <>
                        {startupProfile && startupProfile.sector && caNumber ? (
                          <div className="bg-blue-50 rounded-xl p-5 mb-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Sector-Specific Support</h3>
                            <p className="text-gray-700 mb-3">
                              Your startup is in the <span className="font-semibold">{startupProfile.sector}</span> sector.
                              Contact our dedicated funding expert for specialized assistance.
                            </p>
                            <div className="flex items-center justify-center gap-2 text-lg font-semibold text-blue-700">
                              <Phone className="w-5 h-5" />
                              <span>
                                {loadingNumber ? "loading..." : fundingNumber || getAnyContactNumber()}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div className="bg-purple-50 rounded-xl p-5 mb-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">General Support</h3>
                            <p className="text-gray-700 mb-3">
                              Contact our funding experts for assistance with your fundraising needs.
                            </p>
                            <div className="flex items-center justify-center gap-2 text-lg font-semibold text-purple-700">
                              <Phone className="w-5 h-5" />
                              <span>
                                {loadingNumber ? "loading..." : fundingNumber || getAnyContactNumber()}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="bg-gray-50 rounded-xl p-5 mb-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Support Unavailable</h3>
                        <p className="text-gray-700 mb-3">
                          Our support team contact information is currently being updated.
                        </p>
                        <div className="text-center">
                          <p className="text-sm text-gray-600">
                            Please check back later or email us at support@tactos.in
                          </p>
                        </div>
                      </div>
                    )}

                    {hasContacts() && (
                      <button
                        onClick={() =>
                          handleCallExpert(
                            fundingNumber || getSectorPhoneNumber() || getAnyContactNumber()
                          )
                        }
                        disabled={loadingNumber}
                        className={`w-full font-semibold py-3 px-6 rounded-xl shadow-lg flex items-center justify-center gap-3 transition-all duration-200 
      ${loadingNumber
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white hover:shadow-xl transform hover:scale-105"
                          }`}
                      >
                        <PhoneCall className="w-5 h-5" />
                        {loadingNumber ? "Fetching number..." : "Call Now"}
                      </button>
                    )}
                  </div>
                </div>
              )}

 {previewImage && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md"
          onClick={() => setPreviewImage(null)}
        >
          <motion.img
            src={previewImage}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="
        max-w-[90vw]
        max-h-[90vh]
        rounded-2xl
        shadow-2xl
        cursor-zoom-out
      "
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
            </div>
          </main>
        </div >
      </div >

     
    </>
  )
}

export default AdminForum
